import ActionStore from 'stores/action/ActionStore'
import BootstrapStore from 'stores/bootstrap/BootstrapStore'
import ConfigStore from 'stores/config/ConfigStore'
import DMMFStore from 'stores/dmmf/DMMFStore'
import EnumStore from 'stores/enum/EnumStore'
import ErrorStore from 'stores/error/ErrorStore'
import FieldStore from 'stores/field/FieldStore'
import LayoutStore from 'stores/layout/LayoutStore'
import ModelStore from 'stores/model/ModelStore'
import PersistenceStore from 'stores/persistence/PersistenceStore'
import ProjectStore from 'stores/project/ProjectStore'
import RecordStore from 'stores/record/RecordStore'
import ScriptStore from 'stores/script/ScriptStore'
import SessionStore from 'stores/session/SessionStore'
import TabStore from 'stores/tab/TabStore'
import TelemetryStore from 'stores/telemetry/TelemetryStore'
import ThemeStore from 'stores/theme/ThemeStore'
import UpdateStore from 'stores/update/UpdateStore'

const getStores = () => {
  return {
    ActionStore,
    BootstrapStore,
    ConfigStore,
    DMMFStore,
    EnumStore,
    ErrorStore,
    FieldStore,
    LayoutStore,
    ModelStore,
    PersistenceStore,
    ProjectStore,
    RecordStore,
    ScriptStore,
    SessionStore,
    TabStore,
    TelemetryStore,
    ThemeStore,
    UpdateStore,
  }
}

export default getStores
